import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, withDefaults } from 'vue';

type TabProps = {
  tabList: string[]
};


export default /*#__PURE__*/_defineComponent({
  __name: 'tab',
  props: {
    tabList: { default: () => [] }
  },
  emits: ['clickTab'],
  setup(__props: any, { emit: emits }) {

const props = __props as { tabList: string[] }




const activeTabIndex = ref(0);
const isFirstTabActive = computed(() => activeTabIndex.value === 0);
const isLastTabActive = computed(() => activeTabIndex.value === props.tabList.length - 1);
const onClickTab = (index: number) => {
  activeTabIndex.value = index;
  emits('clickTab', activeTabIndex.value);
};

return { __sfc: true,props, emits, activeTabIndex, isFirstTabActive, isLastTabActive, onClickTab }
}

})